import moment from "moment";

const storePlan = {
    namespaced: true,
    state: {
        planId: null,
        employerId: null,
        planType: null,
        wcaPlanCode: null,
        startDate: null,
        endDate: null,
        minimum: null,
        maximum: null,
        runOutDate: null,
        gracePeriodDate: null,
        terminatedDate: null,
        terminatedRunoutDate: null,
        terminatedGracePeriodDate: null,
        isTerminated: null,
        terminationWorkflowId: null,
        thirdPartyJson: null,
        unionEmployeesEligible: null,
        processingNotes: null,
        disableDebitCard: null,
        subjectToCobra: null,
        eligibilityPeriodTimeframe: null,
        activeEmployeeRunout: null,
        terminatedEmployeeRunout: null,
        terminatedEmployeeReimbursed: null,
        militaryCashOut: null,
        useCustomEligibilityRule: null,
        customEligibilityRule: null,
        rolloverType: null,
        rolloverMax: null,
        rolloverMin: null,
        extensionLength: null,
        fsaMaxIsProrated: null,
        craAllowPostTaxContributions: null,
        hsaIsPreTax: null,
        hsaSingleMax: null,
        hsaFamilyMax: null,
        hsaSingleMaxNextYear: null,
        hsaFamilyMaxNextYear: null,
        planFundingType: null,
        hsaFundingMethod: null,
        hsaEnrollmentType: null,
        hoursPerWeek: null,
        orthodontiaReimbursementType: null,
        employerContributes: null,
        employeeContributes: null,
        employerContributesLumpSum: null,
        craAccountFundedType: null,
        allEligibleExpenses: null,
        dentalExpenses: null,
        visionExpenses: null,
        ppeExpenses: null,
        popOptionsId: null,
        planMaxLimit:null,
        editable: null,
        isTakeover: null,
        takeoverDate: null,
        takeoverOriginalEffectiveDate: null,
        takeoverExistingParticipants: null,
        orderId: null,
        planConverted: null,
        createdDate: null,
        priorPlanId: null,
        firstDataPromoId: null,
        planDisplayName: null,
        isIhFunded: null,
        isHraStackable: null,
        isHraPayrollOnly: null,
        percentAllowedForClaims: null,
        alsoFundsWithDirectDeposit: null,
        useIrsMaximum: null,
        planRolloverMaxLimit: null,
        telescopePlus: null,
        terminationId: null,
        hraOptions: {
            hraOptionsId: null,
            planId: null,
            hraType: null,
            carryoverPercentage: null,
            carryoverAmount: null,
            alternateReplenishDate: null,
            hraUsedForEmployeesOnly: null,
            coversInNetworkDeductible: null,
            coversOutOfNetworkDeductible: null,
            coversCopays: null,
            coversCoinsurance: null,
            coversMedicallyRelatedVision: null,
            coversMedicallyRelatedDental: null,
            coversVision: null,
            coversDental: null,
            coversPrescription: null,
            coversOtc: null,
            coversLab: null,
            coversChiropractic: null,
            coversDoctor: null,
            coversHospital: null,
            coversInsurancePremiumsOnly: null,
            coversInsurancePremiumsAndQualifiedMedicalExpenses: null,
            coversQualifiedMedicalExpensesOnly: null,
            eobRequiredForReimbursement: null,
            primaryToMedicare: null,
            plansTerminateAtEndOfMonth: null,
            includeHraInfoInSbc: null,
            ameriflexTracksDeductible: null,
            hraDeductibleIsEmbedded: null,
            erSingleContribution: null,
            erSpouseContribution: null,
            erChildContribution: null,
            erFamilyContribution: null,
            eeSingleOutOfPocket: null,
            eeSpouseOutOfPocket: null,
            eeChildOutOfPocket: null,
            eeFamilyOutOfPocket: null,
            erFamilyIndividualContribution: null,
            erFamilyTotalContribution: null,
            eeFamilyIndividualOutOfPocket: null,
            eeFamilyTotalOutOfPocket: null,
            midYearParticipantsReceiveFullContribution: null,
            shortYearAccountsCreditedWithFullContribution: null,
            fundsAreAvailableDayOne: null,
            enrollmentNotes: null,
            internalClaimNotes: null,
            dedPlanCode: null,
            coversPpe: null,
            manualCarryover: null,
        }
    },
    getters: {
        storePlan: state => {
            return state;
        },
        maxLimit: state => {
            return state.planMaxLimit ? state.planMaxLimit : null;
        },
        rolloverMaxLimit: state => {
            return state.planRolloverMaxLimit ? state.planRolloverMaxLimit : null;
        }
    },
    actions: {
        async load({commit, state, rootGetters, dispatch}, data){
            let planId = data.planId;
            if (!planId) {
                commit("clearPlan");
                return;
            };
            if (!data.refreshSamePlan && state.planId == planId) return;
            let plan = rootGetters['plans/planById'](planId);
            if(plan) {
                commit("setData", plan);
                await dispatch("loadPlanHraOptions", {planId, employerId: plan.employerId, planType: plan.planType});
                await dispatch("loadPlanMaxLimit",{planId, employerId: plan.employerId});
            } else {
                commit("clearPlan");
                if(planId){
                    throw `The current employer has no plan with PlanId ${planId}.`;
                }
            }
        },
        async update({state, commit, dispatch}, data) {
            let employerId = state.employerId;
            let planId = state.planId;
            if(!employerId || !planId)  return;

            let postData = state;
            _.assign(postData, data);

            if (state.planType == "HRA" && Object.keys(data).length == 1 && data.hraOptions) {
                var validationResponse = await romeApi.post(`employer/${employerId}/plan/${planId}/hraOptions/validate`, postData.hraOptions);
                var allowUpdate = await parseValidation(validationResponse);

                if(!allowUpdate) return;

                await romeApi.post(`employer/${employerId}/plan/${planId}/hraOptions`, postData.hraOptions);
            }
            else {
                var validationResponse = await romeApi.post(`/employer/${employerId}/plan/${planId}/validate`, postData);
                var allowUpdate = await parseValidation(validationResponse);

                if(!allowUpdate) return;

                await romeApi.post(`/employer/${employerId}/plan/${planId}`, postData);
            }

            commit("setData", data);
            await dispatch("plans/updateSinglePlan", {...data, planId: Number(planId)}, {root:true});
            await dispatch("plans/load", {employerId, refreshSameEmployer: true}, {root:true});
            await dispatch("load", {planId, refreshSamePlan: true});

            async function parseValidation(response) {
                if(!response || !response.warnings || !response.warnings.length)
                    return true;

                var warnings = response.warnings.join('<br>');
                warnings += '<br><br>Please confirm this is correct before continuing.'

                return await modalService.confirm(warnings);
            }
        },
        async loadPlanHraOptions({commit}, data) {
            let employerId = data.employerId;
            let planId = data.planId;
            let planType = data.planType;
            if(!employerId || !planId || planType != "HRA") return;

            let hraOptions = await romeApi.get(`employer/${employerId}/plan/${planId}/hraOptions`);
            commit('setPlanHraOptions', hraOptions);
        },
        async loadPlanMaxLimit({commit, state}, data) {
            let planLimits = await romeApi.get(`employer/${data.employerId}/plan/${data.planId}/limits`);
            if (planLimits) {
                if (state.planType == 'PKG' || state.planType == 'TRN') {
                    commit("setPlanMaxLimit", planLimits.craPreTaxLimit);
                }
                else {
                    commit("setPlanMaxLimit", planLimits.planMaxLimit);
                    commit("setPlanRolloverMaxLimit", planLimits.rolloverMaxLimit);
                }
            }
        }
    },
    mutations: {
        setData(state, data) {
            utils.copyCommonProperties(data, state);
        },
        setPlanMaxLimit(state, limit) {
            state.planMaxLimit = limit;
        },
        setPlanRolloverMaxLimit(state, limit) {
            state.planRolloverMaxLimit = limit;
        },
        clearPlan(state) {
            state.planId = null;
            Object.keys(state).forEach( p=> {
                state[p] = null;
            });
        },
        setPlanHraOptions(state, hraOptions) {
          state.hraOptions = hraOptions;
        }
    }
};

function setPlanDescription(plan){
    return plan.description = plan.planType + " " + moment(plan.startDate).format("L") + " - " + moment(plan.endDate).format("L");
}

export default storePlan;



// WEBPACK FOOTER //
// ./src/plans/x-plan.js